<template>
  <div ref="swipeContainer" class="swipe-wrapper">
    <slot></slot>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineEmits } from "vue";
import Hammer from "hammerjs";

const swipeContainer = ref(null);
const emit = defineEmits(["pan-start", "pan-move", "pan-end"]);

let hammerInstance = null;

onMounted(() => {
  if (swipeContainer.value) {
    hammerInstance = new Hammer(swipeContainer.value);

    hammerInstance.add(
      new Hammer.Pan({
        direction: Hammer.DIRECTION_VERTICAL,
        threshold: 0,
      })
    );

    hammerInstance.on("panstart", (e) => emit("pan-start", e));
    hammerInstance.on("panmove", (e) => emit("pan-move", e));
    hammerInstance.on("panend", () => emit("pan-end"));
  }
});

onUnmounted(() => {
  if (hammerInstance) {
    hammerInstance.destroy();
  }
});
</script>

<style scoped>
.swipe-wrapper {
  width: 100%;
  height: auto;
  overflow: hidden;
}
</style>
